import React from 'react';
import { motion } from 'framer-motion';
const timelineEvents = [{
  year: '1880',
  title: 'Born in Odessa',
  description: 'Born Vladimir Yevgenyevich Zhabotinsky into a middle-class Jewish family in the Russian Empire, receiving both a traditional Jewish and Russian education.'
}, {
  year: '1898',
  title: 'Early Journalism in Rome',
  description: 'Traveled to Italy and Switzerland to study law, becoming a foreign correspondent for Odessan newspapers under the pseudonym "Altalena".'
}, {
  year: '1917',
  title: 'The Jewish Legion',
  description: 'Alongside Joseph Trumpeldor, founded the Jewish Legion within the British Army during WWI—the first Jewish military force in two millennia.'
}, {
  year: '1923',
  title: 'The Betar Movement',
  description: 'Founded the Betar youth movement in Riga, emphasizing Jewish self-defense, national pride (Hadar), and military preparedness.'
}, {
  year: '1925',
  title: 'Revisionist Zionism',
  description: 'Established the Alliance of Revisionist Zionists, advocating for a Jewish state with a Jewish majority on both sides of the Jordan River.'
}, {
  year: '1930s',
  title: 'The Evacuation Plan',
  description: 'Warned European Jews of an impending catastrophe, urging a mass evacuation to Palestine—a plea largely dismissed by mainstream leadership.'
}, {
  year: '1940',
  title: 'Death in Exile',
  description: 'Died of a heart attack in New York. Per his will, his remains were only transferred to Israel in 1964 by order of Prime Minister Levi Eshkol.'
}];
export function BiographySection() {
  return <section id="about" className="py-24 md:py-32 bg-[#F5F0E8] relative" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-12">
          <h2 className="text-sm font-medium tracking-[0.2em] text-[#6B1D1D] uppercase mb-4" data-id="element-13">
            Biography
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-[#1A1A1A]" data-id="element-14">
            The Life of Ze'ev Jabotinsky
          </h3>
          <p className="mt-6 text-lg text-[#1A1A1A]/70 max-w-2xl mx-auto font-serif italic" data-id="element-15">
            1880 — 1940
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto" data-id="element-16">
          {/* Center Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-[#1A1A1A]/10 transform md:-translate-x-1/2" data-id="element-17" />

          <div className="space-y-16 md:space-y-24" data-id="element-18">
            {timelineEvents.map((event, index) => {
            const isEven = index % 2 === 0;
            return <motion.div key={event.year} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.8,
              delay: 0.1
            }} className={`relative flex flex-col md:flex-row items-start ${isEven ? 'md:flex-row-reverse' : ''}`} data-id="element-19">
                  {/* Timeline Dot */}
                  <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-[#B8860B] rounded-full transform -translate-x-1/2 mt-2 md:mt-1.5 ring-4 ring-[#F5F0E8]" data-id="element-20" />

                  {/* Content */}
                  <div className={`ml-12 md:ml-0 md:w-1/2 ${isEven ? 'md:pl-16' : 'md:pr-16 text-left md:text-right'}`} data-id="element-21">
                    <span className="text-2xl font-serif text-[#B8860B] mb-2 block" data-id="element-22">
                      {event.year}
                    </span>
                    <h4 className="text-xl font-serif font-semibold text-[#1A1A1A] mb-3" data-id="element-23">
                      {event.title}
                    </h4>
                    <p className="text-[#1A1A1A]/80 leading-relaxed" data-id="element-24">
                      {event.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}